import { Theme, useMediaQuery } from '@mui/material';
import React, { ReactNode } from 'react';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles(
  () => ({
    container: {
      display: 'flex',
    },
  }),
  { name: 'ItemCreationWrapper' },
);

interface IItemCreationWrapperProps {
  children: ReactNode[] | ReactNode;
}

/*
 * IMPORTANT
 * The item creation should be the first child here always
 */
export const ItemCreationWrapper = ({ children }: IItemCreationWrapperProps) => {
  const { classes } = useStyles();

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  // on mobile only display the item creation itself. Don't display the info section.
  if (isMobile) {
    return <>{Array.isArray(children) ? children[0] : children}</>;
  }

  return <div className={classes.container}>{children}</div>;
};
